export default "__VITE_ASSET__3c771dce__"